<template>
    <el-dialog class="dialog" :title="$t('pgCommon.CONFIG')" :visible.sync="configStatus" :close-on-click-modal="false" @close="closeDialog" :width="LeveWidth+'px'">
        <div class="config">
            <el-collapse v-model="activeName" accordion>
                <el-form inline>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item v-if="title === $t('pgCommon.USERNAME')" :label="$t('pgCommon.USERNAME') + '：'">
                                <td-input v-model="chooseUser" disabled>
                                    <span slot="append" class="userBtn" :disabled="chooseUser">
                                        <i class="el-icon-circle-close" v-if="chooseUser && !fettle" @click="clearChoUser"></i>
                                        <el-button :circle="false" size="small" @click="showDialog" :disabled="fettle">{{ $t('pgCommon.CHOOSE') }}</el-button>
                                    </span>
                                </td-input>
                            </el-form-item>
                            <el-form-item v-else :label="$t('pgCommon.SORTNAME') + '：'">
                                <td-select v-if="!fettle" v-model="chooseSortId" :disabled="fettle" :options="options" keys="roleId" text="roleName"></td-select>
                                <td-select v-else v-model="chooseSort" :disabled="fettle"></td-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('pgCommon.ALARM_TYPE') + '：'">
                                <td-input v-model="sortInput" :placeholder="$t('pgError.ERROR_INPUT_PROPERTY_NAME_NULL')"></td-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-collapse-item name="1">
                    <template slot="title">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{ $t('pgCommon.CONFIG_ALARM') }}</el-checkbox>
                    </template>
                    <el-checkbox-group v-model="checkeds" @change="handleCheckedCitiesChange">
                        <el-checkbox class="el-checkbox-width" :title="item.sName" v-for="item in initEventData" :label="item.sId" :key="item.sId">{{ item.sName }}</el-checkbox>
                    </el-checkbox-group>
                </el-collapse-item>
                <div class="dialog-footer">
                    <td-button type="primary" @click="saveData">{{ $t('pgCommon.SAVE') }}</td-button>
                    <td-button @click="closeDialog">{{ $t('pgCommon.CLOSE') }}</td-button>
                </div>
            </el-collapse>
        </div>
        <el-dialog :visible.sync="show" :title="$t('pgCommon.USER_CHOOSE')" width="30%" append-to-body>
            <td-tree
                :lazyloading="lazyloading"
                :height="400"
                :isDbClick="true"
                :calInternal="true"
                :imgloading="true"
                ref="TdTree"
                @onDbClick="onDbClick"
                :showBox="false"
                :isPaging="true"
                :expandOnClick="true"
                :defaultProps="defaultProps"
                :nodeKey="nodeKey"
                :interfaceName="interfaceName"
                :inputShow="inputShow"
                :params="params"
            >
            </td-tree>
        </el-dialog>
    </el-dialog>
</template>

<script>
import api from '../../alarmEvent/assets/api';
import Api from '../assets/api';

export default {
    name: 'allotDialog',
    props: ['configStatus', 'checkList', 'title', 'fettle', 'name'],
    data() {
        return {
            LeveWidth:650,
            chooseUser: '',
            chooseUserId: '',
            chooseSortId: '',
            chooseSort: '',
            options: [],
            sortInput: '',
            show: false,
            activeName: '1',
            checkAll: false,
            isIndeterminate: false,
            sortData: [],
            initEventData: [],
            checked: [],
            checkeds: [],
            nodeKey: 'id',
            onClick: true,
            interfaceName: {
                query: '/staffManager/queryStaffOrgTree',
                search: '/staffManager/getStaffInfoByCaption'
            },
            params: {
                currentPage: 1,
                needPage: true,
                pageSize: 50
            },
            lazyloading: true,
            // 搜索框是否显示
            inputShow: true,
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon'
            },
            imgloading: true,
            treeKey: 0
        };
    },
    watch: {
        sortInput(val) {
            this.initEventData = [];
            if (val) {
                this.sortData.forEach(item => {
                    if (item.sName.indexOf(val) !== -1) {
                        this.initEventData.push(item);
                    }
                });
            } else {
                this.initEventData = this.sortData;
            }
        },
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.LeveWidth = 650 + (Number(newVal) == 14 ? 0 : Number(newVal) + 120);
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },

    mounted() {
        this.getAlarmEventAll();
        if (this.title === this.$t('pgCommon.SORTNAME')) {
            this.querySortList();
        }
        this.chooseUser = this.name;
        this.chooseSort = this.name;
    },
    methods: {
        clearChoUser() {
            this.chooseUserId = '';
            this.chooseUser = '';
        },
        showDialog() {
            this.show = true;
        },
        querySortList() {
            let params = {
                roleType: 0,
                currentPage: 1,
                pageSize: 2147483647
            };
            Api.querySortList(params, res => {
                if (res.data.statusCode === 'API-COMMON-INF-OK') {
                    this.options = res.data.content;
                }
            });
        },
        onDbClick(val) {
            if (this.treeKey > 0) {
                if (val.iType === 1000) {
                    this.chooseUser = val.caption;
                    this.chooseUserId = val.sId;
                    this.show = false;
                } else {
                    this.$message({
                        type: 'warning',
                        message: this.$t('pgCommon.NO_PEOPLE')
                    });
                }
            }
            this.treeKey++;
        },
        getAlarmEventAll() {
            api.getAlarmEventAll('', res => {
                if (res.data.content !== null && res.data.content !== '') {
                    this.sortData = res.data.content;
                    this.sortData.forEach(item => {
                        this.checked.push(item.sId);
                    });
                    this.initEventData = this.sortData;
                    this.checkeds = this.checkList;
                    if (this.checked.length === this.checkeds.length) {
                        this.checkAll = true;
                    } else if (this.checkList.length !== 0) {
                        this.isIndeterminate = true;
                    }
                }
            });
        },
        handleCheckAllChange(val) {
            this.checkeds = val ? this.checked : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(val) {
            this.checkeds = val;
            let checkedCount = val.length;
            this.checkAll = checkedCount === this.initEventData.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.initEventData.length;
        },
        saveData() {
            if (this.title === this.$t('pgCommon.USERNAME')) {
                if (this.chooseUserId !== '' && !this.fettle) {
                    this.$emit('saveData', this.checkeds, this.chooseUserId);
                } else if (this.chooseUserId === '' && this.fettle) {
                    this.$emit('saveData', this.checkeds);
                } else {
                    this.$message({
                        type: 'error',
                        message: this.$t('pgCommon.PLEASE_USER')
                    });
                }
            } else {
                if (this.chooseSortId !== '' && !this.fettle) {
                    this.$emit('saveData', this.checkeds, this.chooseSortId);
                } else if (this.chooseSortId === '' && this.fettle) {
                    this.$emit('saveData', this.checkeds);
                } else {
                    this.$message({
                        type: 'error',
                        message: this.$t('pgCommon.PLEASE_SORT')
                    });
                }
            }
        },
        closeDialog() {
            this.$emit('closeDialog');
        }
    }
};
</script>

<style scoped>
.headerDiv {
    display: inline-block;
    width: 50%;
}
.userBtn .el-button {
    border: 0;
}
.userBtn .el-icon-circle-close {
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: -25%;
    transform: translate(-50%, -50%);
}
.el-checkbox-width {
    width: 150px;
    height: 25px;
}
.el-checkbox-width >>> .el-checkbox__label {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
}

.dialog >>> .el-dialog .config {
    height: 600px;
    overflow: hidden;
    padding: 0 20px;
}
.dialog >>> .el-dialog .config .el-collapse {
    height: 98%;
    border-top: none;
    border-bottom: none;
}
.dialog >>> .el-dialog .config .el-collapse .el-form {
    padding-top: 0;
    margin-bottom: 0;
}
.dialog >>> .el-dialog .config .el-collapse-item {
    height: 85%;
}
.dialog >>> .el-dialog .config .el-collapse-item__wrap {
    height: 90%;
    overflow-y: auto !important;
}
.dialog >>> .el-dialog .el-dialog__body {
    padding: 10px 0 10px;
    overflow: hidden;
}
.dialog-footer {
    padding: 10px 0;
    text-align: center;
}
.el-collapse >>> .el-collapse-item__wrap {
    max-height: 450px;
}

</style>
